"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intersect = void 0;

var _findIndex = require("../find-index/find-index");

var _curry = require("../curry/curry");

var _intersect = function _intersect(predicateFn, unionFn, aList, bList) {
  if (aList.length === 0) {
    return bList;
  }

  if (bList.length === 0) {
    return aList;
  }

  var result = [].concat(aList);

  var _loop = function _loop(index) {
    var b = bList[index];
    var aIndex = (0, _findIndex.findIndex)(function (item) {
      return predicateFn(item, b);
    })(result);

    if (aIndex === -1) {
      result.push(b);
    } else {
      result[aIndex] = unionFn(result[aIndex], b);
    }
  };

  for (var index = 0; index < bList.length; ++index) {
    _loop(index);
  }

  return result;
};

var intersect = (0, _curry.curry)(_intersect);
exports.intersect = intersect;